exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".weekoff {\n  color: #58581f; }\n\n.holiday {\n  color: red; }\n\n.leave {\n  color: blue; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/attendance/attendance-tab-me/attendance-tab-me.component.scss
// module id = ../../../../../src/app/hrms/attendance/attendance-tab-me/attendance-tab-me.component.scss
// module chunks = main